import { AttachmentFile, AttachmentsForDialog } from '@qality/common-model';

export default {
  attachmentURLCreator(attachment: Array<File>): AttachmentsForDialog {
    return attachment.map((item) => {
      // @ts-expect-error <to fix this error we need to return new object with item properties and it's easiest to do with spread operator but it will causes errors later on>
      item.content = URL.createObjectURL(item);
      return item as AttachmentFile;
    });
  },
};
